module.exports = __webpack_public_path__ + "img/dress3.ff6d7b46.jpeg";